import { createPinia } from 'pinia';

const pinia = createPinia();

if (import.meta.env.DEV) {
  // Pinia automatically installs its devtools plugin in dev builds.
  // With very large stores, Vue Devtools can become extremely slow because it
  // serializes and tracks every mutation for the Pinia inspector/timeline.
  const mode = 'skip-multiprojects'; // keep Pinia devtools, but skip the huge multiprojects store
  // const mode = 'off'; // disable Pinia devtools plugin (big perf win on huge stores)
  // const mode = 'on'; // keep Pinia devtools enabled

  // Pinia queues its internal devtools plugin in a private list until `app.use(pinia)` calls `pinia.install()`.
  const originalInstall = pinia.install;
  pinia.install = (app) => {
    originalInstall.call(pinia, app); // call the original pinia install
    if (mode === 'on') return; // keep Pinia devtools enabled

    // eslint-disable-next-line no-underscore-dangle
    const plugins = pinia?._p;
    if (! Array.isArray(plugins)) return;

    const devtoolsPluginIndex = plugins.findIndex(plugin => plugin.name === 'devtoolsPlugin');
    if (devtoolsPluginIndex === -1) return; // Pinia devtools plugin not found

    if (mode === 'off') {
      plugins.splice(devtoolsPluginIndex, 1); // disable Pinia devtools plugin entirely
      return;
    }
    if (mode === 'skip-multiprojects') {
      const original = plugins[devtoolsPluginIndex];
      plugins[devtoolsPluginIndex] = (context) => {
        if (context?.store?.$id === 'multiprojects') return undefined;
        if (context?.store?.$id === 'multiprojects-plannings') return undefined;
        return original(context);
      };
    }
  };
}

export default pinia;
